// takes a destination for the router and returns it with a locale param
import { Route } from 'vue-router'
import Vue from 'vue'

const I18nTo = {
  install(VueInstance: typeof Vue, options: { defaultLocale: string }) {
    const defaultLocale = options?.defaultLocale || 'en'

    VueInstance.prototype.$i18nTo = function $i18nTo(to: Route) {
      const { locale } = this.$i18n

      const param = locale === defaultLocale ? {} : { locale }

      return {
        ...to,

        params: {
          ...(to.params || {}),
          ...param,
        },
      }
    }
  },
}

export default I18nTo
